import { render, staticRenderFns } from "./FolderMultipleIcon.vue?vue&type=template&id=616290e2"
import script from "./FolderMultipleIcon.vue?vue&type=script&lang=js"
export * from "./FolderMultipleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports